<template>
  <div class="content">
    <div class="header">
      <div class="header-tip">
        申请房产数：{{pageData.total}}
      </div>

      <el-select placeholder="账龄类型" clearable v-model="where2.age">
        <el-option :value="1" label="当期"></el-option>
        <el-option :value="2" label="纯上一年"></el-option>
        <el-option :value="3" label="1年以上2年以内"></el-option>
        <el-option :value="4" label="2年以上"></el-option>
      </el-select>

      <el-button @click="getExcel">导出</el-button>


    </div>

    <div class="body">
      <div>
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            v-if="pageData" :data="pageData.list"
            border
            style="width: 100%">
            <el-table-column
              prop="房产信息"
              label="房产信息" width="320" fixed></el-table-column>
            <el-table-column
              prop="区域"
              label="区域"
              width="90">
            </el-table-column>
            <el-table-column
              prop="业主"
              label="业主姓名"
              width="100">
            </el-table-column>
            <el-table-column
              prop="业主电话"
              label="业主电话"
              width="150">
            </el-table-column>
            <el-table-column
              label="银行划扣"
              width="90">
              <template slot-scope="scope">
                <span style="color: #328628" v-if="scope.row.bankType">是</span>
                <span v-if="!scope.row.bankType"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="欠费起始月份"
              label="欠费起始月份"
              width="120">
            </el-table-column>
            <el-table-column
              prop="欠费月数"
              label="欠费月数"
              width="100">
            </el-table-column>
            <el-table-column
              prop="欠费金额"
              label="欠费金额"
              width="100">
              <template slot-scope="scope">
                <el-link type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row['欠费金额'] }}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="催缴类型"
              label="催缴类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="第三方合作单位"
              label="第三方合作单位"
              width="150">
            </el-table-column>
            <el-table-column
              prop="账龄类型"
              label="账龄类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="计划催缴月份"
              label="计划催缴月份"
              width="100">
            </el-table-column>
            <el-table-column
              prop="上次缴费时间"
              label="上次缴费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第一次催费时间"
              label="第一次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第二次催费时间"
              label="第二次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第三次催费时间"
              label="第三次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="催费次数"
              label="催费次数"
              width="90">
            </el-table-column>
            <el-table-column
              prop="欠费类型"
              label="欠费类型"
              width="150">
            </el-table-column>
<!--            <el-table-column-->
<!--              prop="欠费原因"-->
<!--              label="欠费原因"-->
<!--              width="150">-->
<!--            </el-table-column>-->
            <el-table-column
              prop="业主诉求"
              label="业主诉求"
              width="150">
            </el-table-column>
            <el-table-column
              prop="解决措施"
              label="催费措施"
              width="150">
            </el-table-column>
            <el-table-column
              prop="flow_status"
              label="审核状态"
              width="80">
              <template slot-scope="scope">
                <el-link type="danger" size="mini" v-if="scope.row.flow_status==='驳回'">{{scope.row.flow_status}}</el-link>
                <el-link type="primary" size="mini" v-if="scope.row.flow_status!=='驳回'">{{scope.row.flow_status}}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180">
              <template slot-scope="scope">
<!--                <el-button type="primary" size="mini" @click="editType(scope.row)">变更催缴</el-button>-->
                <el-button type="danger" size="mini" @click="rejectHandel(scope.row)" v-if="scope.row.flow_status!=='驳回'">驳回</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
      <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

        <div class="view-file-win">
          <el-descriptions class="margin-top" :column="1" size="mini" border>
            <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
            <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
            <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
            <el-descriptions-item label="催缴类型">
              <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
                <el-option value="自催" label="自催"></el-option>
                <el-option value="诉讼" label="诉讼"></el-option>
                <el-option value="第三方" label="第三方"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
            <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
            <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>
            <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <template slot="footer">
          <div>
            <el-button @click="onClose">关 闭</el-button>
            <el-button @click="editTypeSubmit">修 改</el-button>
          </div>
        </template>
      </el-dialog>
    </div>


    <el-dialog title="驳回" :visible.sync="dialogVisible2" :close-on-click-modal="false" @close="onClose" width="1000px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="催缴类型">
            <el-select disabled placeholder="催缴类型" v-model="from_data['催缴类型']">
              <el-option value="自催" label="自催"></el-option>
              <el-option value="诉讼" label="诉讼"></el-option>
              <el-option value="第三方" label="第三方"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>
          <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
          <el-descriptions-item label="驳回理由">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入驳回理由 "
              v-model="textarea">
            </el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button icon="el-icon-close" @click="onClose">关 闭</el-button>
          <el-button @click="rejectSubmit">确 认</el-button>
        </div>
      </template>
    </el-dialog>

    <LegalHouseMoneyList ref="legalHouseMoneyListRef" />
  </div>
</template>

<script>
import Http from "../../common/Http";
import ButlerHttp from "../../common/ButlerHttp";
import LegalHouseMoneyList from "../LegalHouseMoneyList";

export default {
  name: "ThirdPartyLegalPlanFlow",
  components: {LegalHouseMoneyList},
  data(){
    return{
      where2:{
        urge_type:3,
        age:"",
        type:""
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      from_data:{},
      dialogVisible:false,
      dialogVisible2:false,
      batch_number:"",
      textarea:"",
    }
  },
  mounted() {
    const that=this;
    that.batch_number=that.$route.query.batch_number
    that.getList();
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
      }

      ButlerHttp.post("ThirdPartyLegal/getLegalHouseFlowBatchNumberList", {
        ...where,
        batch_number: that.batch_number,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getExcel(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
      }

      ButlerHttp.post("ThirdPartyLegal/getLegalHouseFlowBatchNumberEexcl", {
        ...where,
        batch_number: that.batch_number
      }, res => {
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editType(item){
      const that=this;
      that.from_data=item;
      that.dialogVisible=true;
    },
    onClose(){
      this.dialogVisible=false;
      this.dialogVisible2=false;
      this.from_data={}
    },
    editTypeSubmit(){
      const that=this;
      let urge_type_obj={
        '自催':1,
        '诉讼':2,
        '第三方':3
      }
      ButlerHttp.post("ThirdPartyLegal/updateLegalHouseType", {
        id: that.from_data.id,
        ch_md5: that.from_data.ch_md5,
        urge_type: urge_type_obj[that.from_data['催缴类型']]
      }, res => {
        if (res.code) {
          that.onClose();
          that.$message.success("操作成功");
          that.pageChange(1);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    rejectHandel(item){
      const that=this;
      that.dialogVisible2=true;
      that.from_data=item;
    },
    rejectSubmit(){
      const that=this;
      ButlerHttp.post("ThirdPartyLegal/rejectSave", {
        id: that.from_data.flow_id,
        textarea: that.textarea
      }, res => {
        if (res.code) {
          that.dialogVisible2 = false;
          that.getList();
        } else {
          that.$message.error(res.msg || "操作异常");
        }
      });
    },
    getHouseBill(item){
      const that=this;
      that.$refs.legalHouseMoneyListRef.show({
        project_id:item.PrecinctID,
        house_id:item.HouseID,
      })
    },
  },
  watch:{
    "where2.age":function (n) {
      this.pageChange(1)
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  //min-height: calc(100vh - 350px);
  background-color: #FFFFFF;
  padding: 10px 20px;

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }

  .header-btn{
    .btn-item{
      margin: 5px 20px;
    }
  }

  .pagination-wrap {
    margin-top: 10px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ThirdPartyLegalPlanFlow.vue